import React from "react";
import { TourDaTela } from "../features/tour";
import { TOUR_VISAO_GERAL } from "../features/tour/roteiros/visaoGeral";
import { CopaBanner } from "../features/copa";
import { BannerPainel } from "../features/banner-painel";
import { useVisaoGeral } from "../features/visao-geral/useVisaoGeral";
import Alertas from "../features/visao-geral/components/Alertas";
import FaturamentoMensal from "../features/visao-geral/components/FaturamentoMensal";
import VendasHoje from "../features/visao-geral/components/VendasHoje";
import RelatoriosMes from "../features/visao-geral/components/RelatoriosMes";
import Resumo from "../features/visao-geral/components/Resumo";
import "../features/visao-geral/visaoGeral.css";

/**
 * Visão Geral repaginada (modelo nucleo-visao-geral-v3.html do dono,
 * novembro de 2026). Cada bloco tem a própria rota (backend/api/v1/visao_geral)
 * e carrega sozinho, com animação nos cartões; os dados ficam em memória ao
 * trocar de tela e VENDAS DE HOJE se atualiza a cada 60 s
 * (features/visao-geral/useVisaoGeral.js). Sem botão Atualizar (decisão do
 * dono, 23/10/2026): o resto da tela atualiza com F5.
 */
export default function VisaoGeral() {
  const { dados, erros, atualizadoEm, atualizarTudo } = useVisaoGeral();
  const falhou = ["hoje", "mensal", "mes", "resumo"].some((b) => erros[b] && dados[b] === undefined);
  const hora = atualizadoEm ? atualizadoEm.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : null;

  return (
    <div className="vg">
      <main className="vg-page">
        {/* Tour de primeira visita: só decide depois que os blocos com alvo
            chegaram — decidir antes descartaria passos ainda carregando. */}
        <TourDaTela
          tela={TOUR_VISAO_GERAL.tela}
          roteiro={TOUR_VISAO_GERAL.passos}
          papeis={TOUR_VISAO_GERAL.papeis}
          pronto={Boolean(dados.hoje && dados.mensal && dados.mes && dados.resumo)}
        />
        {/* Banner do Núcleo para todas as lojas (some quando não há) */}
        <BannerPainel />
        <CopaBanner />
        <div className="vg-title">
          <div>
            <h1>Visão Geral</h1>
            <p>Painel de controle do sistema</p>
          </div>
          <div className="vg-meta">
            {hora && <span>Dados de {hora}</span>}
          </div>
        </div>
        {falhou && (
          <div className="vg-al warn" style={{ marginBottom: 16 }}>
            <span className="vg-ic">!</span>
            <div><b>Parte da tela não carregou</b><small>Confira a internet e tente de novo.</small></div>
            <button type="button" onClick={atualizarTudo}>Tentar de novo</button>
          </div>
        )}
        <Alertas mes={dados.mes} />
        <FaturamentoMensal dados={dados.mensal} />
        <VendasHoje dados={dados.hoje} />
        <RelatoriosMes mes={dados.mes} horarios={dados.horarios} />
        <Resumo resumo={dados.resumo} />
      </main>
    </div>
  );
}
